<template>
  <div class="ems-main">
    <div>
      <button @click="getListMaster('user')">User</button>
      <button @click="getListMaster('employee')">Employee</button>
      <button @click="getListMaster('team')">Team</button>
      <button @click="getListMaster('role')">Role</button>
      <button @click="getListMaster('branch')">Branch</button>
      <button @click="getListMaster('normal')">Normal array</button>
      <button @click="getListMaster('string')">String</button>

      <button @click="useZero = !useZero">Use Zero</button>
      {{ useZero }}
    </div>
    <InputQuery :items="dropdownList" :placeholder="placeholder" :descKey="description" style="margin-bottom: 10px"/>

    <button @click="showEntry('job')">Job Entry</button>
    <button @click="showEntry('vehicle')">Vehicle Entry</button>

    <EntryPopup :show.sync="showPopup" :title="entryTitle" :content="entryContent" saveController="/SampleData/SubmitJob"
      @saved="saveDone" :messages.sync="entryMessages" :errorMessages="entryError"/>

    <!-- <Input :isDisabled="true"/> -->

    <!-- <Dropdown :placeholder="placeholder" :items="dropdownList"/> -->

    <!-- <div style="height: 500px">
      <Table :tableData="dropdownList" :multiSelect="false" :firstRowIsType="false" @cellButtonClick="cellButtonClick"/>
    </div> -->

    <Loader :isVisible="loading" :loadingText="loadingText"/>
  </div>
</template>

<script>
/* eslint-disable */
import DateTimePicker from '@/components/DateTimePicker.vue';
import Loader from '@/components/Loader.vue';
import Table from '@/components/Tabulator.vue';
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import EntryPopup from '@/components/EntryPopup.vue';

export default {
  components: {
    DateTimePicker, Loader, Table, Input, InputQuery, Dropdown, EntryPopup
  },
  props: {
    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    description: { type: String, default: '' },
    useZero: { type: Boolean, default: false },

    dropdownList: { type: Array, default: function() { return [] } },
    showPopup: { type: Boolean, default: false },
    entryTitle: { type: String, default: '' },
    entryContent: { type: Array, default: function() { return [] }},
    entryMessages: { type: Array, default: function() { return [] }},
    entryError: { type: Array, default: function() { return [] }}
  },
  methods: {
    getListMaster: async function(master) {
      switch (master) {
        case 'user':
          this.placeholder = 'UserID';
          this.description = 'User Name';
          break;
        case 'employee':
          this.placeholder = 'Employee';
          this.description = 'Position';
          break;
        case 'team':
          this.placeholder = 'Team';
          this.description = 'Description';
          break;
        case 'branch':
          this.placeholder = 'Branch Code';
          this.description = 'Branch Name';
          break;
        case 'role':
          this.placeholder = 'Role';
          this.placeholder = 'Description';
          break;
      }
      if (master != 'string' && master != 'normal') {
        this.loading = true;
        this.loadingText = `Getting ${master}`;

        var result = await this.$apiCallV2(`/UserManagement/GetListMaster?master=${master}`);

        if (this.useZero) {
          var obj = {};
          Object.keys(result.data[0]).forEach((k) => {
            if (k == '#') {
              obj['#'] = 0;
            } else {
              obj[k] = typeof(result.data[0][k]);
            }
          });
          result.data.splice(0, 0, obj);
        }
        
        this.placeholder = master[0].toUpperCase() + master.substring(1);
        this.dropdownList = result.data;

        console.log(result.data);

        this.loading = false;
      } else if (master == 'string') {
        this.dropdownList = [ 'Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6', 'Item 7', 'Item 8', 'Item 9', 'Item 10', 'Item 11' ];
      } else {
        this.dropdownList = [
          // { '#': '1', 'User Name': 'string||Test', Age: 'number', DOB: 'date' },
          { '#': '1', 'User Name': 'Muhammad Azizi bin Abdul Aziz', Age: 25, DOB: new Date(1993, 6, 13, 0, 0, 0) },
          { '#': '2', 'User Name': 'Amar', Age: 32, DOB: new Date(1993, 4, 2, 0, 0, 0) },
          { '#': '3', 'User Name': 'Zhen Hao', Age: 23, DOB: new Date(1993, 8, 31, 0, 0, 0) },
          { '#': '4', 'User Name': 'Tien Wern', Age: 56, DOB: new Date(1993, 12, 31, 0, 0, 0) },
          { '#': '5', 'User Name': 'Hannah', Age: 27, DOB: new Date(1993, 2, 8, 0, 0, 0) },
          { '#': '6', 'User Name': 'Sue', Age: 35, DOB: new Date(1993, 4, 6, 0, 0, 0) },
          { '#': '7', 'User Name': 'SWLim', Age: 58, DOB: new Date(1993, 3, 31, 0, 0, 0) },
          { '#': '8', 'User Name': 'TJLim', Age: 24, DOB: new Date(1993, 7, 15, 0, 0, 0) },
          { '#': '9', 'User Name': 'HALim', Age: 56, DOB: new Date(1993, 1, 18, 0, 0, 0) },
          { '#': '10', 'User Name': 'Nancy', Age: 42, DOB: new Date(1993, 2, 21, 0, 0, 0) },
          { '#': '11', 'User Name': null, Age: 78, DOB: new Date(1993, 3, 27, 0, 0, 0) }
        ];

        if (this.useZero) {
          this.dropdownList.splice(0, 0, { '#': '0', 'User Name': 'string', Age: 'number', DOB: 'date' })
        }
      }
    },
    rowSelected: function(e) {
      var branch = this.branchList.filter((b) => { return b['Branch Code'] == e.Branch });

      this.selectedBranch = branch[0];
    },
    showEntry: function(entryFor) {
      this.showPopup = true;
      this.entryContent = [];
      switch (entryFor) {
        case 'job':
          this.entryTitle = 'Job Entry';
          this.entryContent.push([
            { type: 'input', name: 'JobID', placeholder: 'Job ID', isRequired: true },
            { type: 'input', name: 'JobDesc', placeholder: 'Job Description' }
          ]);
          this.entryContent.push([
            { type: 'input', name: 'Addr1', placeholder: 'Address Line 1', isRequired: true },
            { type: 'input', name: 'Addr2', placeholder: 'Address Line 2', isRequired: true },
            { type: 'input', name: 'Addr3', placeholder: 'Address Line 3' },
            { type: 'input', name: 'Addr4', placeholder: 'Address Line 4' },
            { type: 'input', name: 'PostCode', placeholder: 'Postal Code', isRequired: true },
            { type: 'input', name: 'State', placeholder: 'State', isRequired: true },
          ]);
          break;
        case 'vehicle':
          this.entryTitle = 'Vehicle Entry';
          this.entryContent.push([
            { type: 'input', name: 'JobID', placeholder: 'Vehicle ID', isRequired: true },
            { type: 'input', name: 'JobDesc', placeholder: 'Vehicle Description' },
            { type: 'input', name: 'Addr1', placeholder: 'Address Line 1', isRequired: true },
            { type: 'input', name: 'Addr2', placeholder: 'Address Line 2', isRequired: true },
            { type: 'input', name: 'Addr3', placeholder: 'Address Line 3' },
            { type: 'input', name: 'Addr4', placeholder: 'Address Line 4' },
            { type: 'input', name: 'PostCode', placeholder: 'Postal Code', isRequired: true },
            { type: 'input', name: 'State', placeholder: 'State', isRequired: true },
            { type: 'input', name: 'JobID', placeholder: 'Vehicle ID', isRequired: true },
            { type: 'input', name: 'JobDesc', placeholder: 'Vehicle Description' },
            { type: 'input', name: 'Addr1', placeholder: 'Address Line 1', isRequired: true },
            { type: 'input', name: 'Addr2', placeholder: 'Address Line 2', isRequired: true },
            { type: 'input', name: 'Addr3', placeholder: 'Address Line 3' },
            { type: 'input', name: 'Addr4', placeholder: 'Address Line 4' },
            { type: 'input', name: 'PostCode', placeholder: 'Postal Code', isRequired: true },
            { type: 'input', name: 'State', placeholder: 'State', isRequired: true },
          ]);
          break;
      }
    },
    cellButtonClick: function(btn, rowData) {
      // console.log(btn);
      // console.log(rowData);
    },
    saveDone: function(item) {
      if (item.Results == 0) {
        this.entryMessages.push('Succesfully saved!');
      } else {
        this.entryError.push(item.ErrMsg);
      }
    }
  },
  async mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.ems-main {
  padding: 10px 40px;
  height: 100%;
  position: relative;
  // background-color: red;
  box-sizing: border-box;
  // display: flex;
}

button {
  margin-left: 3px;
}
</style>